import { addProductsToWishlist } from '../store/wishlist/thunks.js';
import './logToSlack.js';
import parseJSON from './parseJSON.js';
import 'cookies-next';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import { a as LOCAL_STORAGE_ADD_WISHLIST_PRODUCT } from '../localStorage-h6SlcHvK.js';
import '../payment-a4IKjS7g.js';
import './currency.js';
import 'react';
import '../context/index.js';
import 'lodash/get';
import '../product-_pRduMz7.js';
import 'next/router';
import '../helpers-WYINLSKJ.js';
import 'lodash';
import '@reduxjs/toolkit';
import '../RemoveProductsFromWishlist-WCaYiZlq.js';
import '../requestsCollection-A0HzS4ai.js';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../services/auth/index.js';
import './cookies.js';
import '../cookies-VX_DpI1q.js';
import './isBot.js';
import './fetchPolicyLookup.js';
import './error.js';
import '../serverErrors-O6unZmFR.js';
import './logger.js';
import './logToRelic.js';
import '../wishlist-foOHzuD7.js';
import './product.js';
import '../paths-ZKN3m62_.js';

const addProductToWishlistAfterAuth = async (
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-explicit-any
dispatch, 
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-explicit-any
wishlists) => {
    const wishlistProduct = parseJSON(localStorage.getItem(LOCAL_STORAGE_ADD_WISHLIST_PRODUCT));
    const sku = wishlistProduct === null || wishlistProduct === void 0 ? void 0 : wishlistProduct.sku;
    const selectedOptions = wishlistProduct === null || wishlistProduct === void 0 ? void 0 : wishlistProduct.selectedOptions;
    if (sku && selectedOptions) {
        await dispatch(addProductsToWishlist({
            wishlistId: wishlists[0].id,
            wishlistItems: [
                {
                    sku,
                    selected_options: selectedOptions,
                    quantity: 1,
                },
            ],
        }));
        localStorage.removeItem(LOCAL_STORAGE_ADD_WISHLIST_PRODUCT);
    }
};

export { addProductToWishlistAfterAuth };
//# sourceMappingURL=wishlist.js.map
